const addPropertyIfTruthy = (targetObject, propertyName, value) => {
  if (value) {
    targetObject[propertyName] = value;
  }
};

export default addPropertyIfTruthy;